module.exports = __webpack_public_path__ + "static/media/grupcepas.b3ec5917.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/grupcepas.jpg
// module id = 947
// module chunks = 0